import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  listCalculationParameters,
  updateCalculationParameter,
  type CalculationParameter,
  type CalculationParameterList,
  type UpdateCalculationParameterBody,
} from "../api/calculationParameters";

const KEY = "calculation-parameters";

/** Calculation parameters (Globals + per cost model) from svc-04
 *  `/v1/admin/calculation-parameters`. */
export function useCalculationParameters() {
  return useQuery<CalculationParameterList>({
    queryKey: [KEY, "list"],
    queryFn: () => listCalculationParameters(),
    staleTime: 30_000,
  });
}

/** PATCH /v1/admin/calculation-parameters/:id — edit one parameter. */
export function useUpdateCalculationParameter() {
  const queryClient = useQueryClient();
  return useMutation<
    CalculationParameter,
    Error,
    { id: string; body: UpdateCalculationParameterBody }
  >({
    mutationFn: ({ id, body }) => updateCalculationParameter(id, body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEY] });
    },
  });
}
